import { PillItem } from "@search/api/types";
import BooleanFilter from "@search/store/filters/primitive/BooleanFilter";

class ReviewsFilter extends BooleanFilter {
  constructor(value: boolean) {
    super({
      defaultValue: false,
      label: "Reviews",
      name: "reviews",
      value,
    });
  }

  toPills(): Array<PillItem> {
    const pills: Array<PillItem> = [];

    if (this.isSet()) {
      pills.push({
        key: "Rated Very Good +",
        name: this.name,
      });
    }

    return pills;
  }
}

export default ReviewsFilter;
export { ReviewsFilter };
